<template>
	<!-- 开户 -->
	<div class="content scroll-container">
		<div class="reg-header">
			<img src="../assets/log.png" alt="">
		</div>
		<div class="container">
			<el-form ref="form" :model="form" :rules="rules" label-width="180px">
				<h2>亚普达客户开户系统</h2>
				<div class="check-baseinfo currform">
					<el-form-item label="公司代码" prop="cocode">
						<el-input v-model="form.cocode" placeholder="八位以内的英文或数字" maxlength="8"></el-input>
					</el-form-item>
					<el-button type="primary" plain class="reg-button" @click="checkCocode()">检查是否可用</el-button>
					<el-form-item label="公司简称" prop="shortna">
						<el-input v-model="form.shortna"></el-input>
					</el-form-item>
					<el-form-item label="公司全称" prop="fullna">
						<el-input v-model="form.fullna" placeholder="与营业执照一致的信息"></el-input>
					</el-form-item>
					<el-form-item label="英文名称">
						<el-input v-model="form.engna"></el-input>
					</el-form-item>
					<el-form-item label="公司电话" prop="telno">
						<el-input v-model="form.telno"></el-input>
					</el-form-item>
					<el-form-item label="公司传真">
						<el-input v-model="form.faxno"></el-input>
					</el-form-item>
					<el-form-item label="邮编">
						<el-input v-model="form.zipcode"></el-input>
					</el-form-item>
					<el-form-item label="详细地址" prop="addr">
						<el-input v-model="form.addr"></el-input>
					</el-form-item>
					<el-form-item label="经济类型" prop="ectype">
						<el-select v-model="form.ectype" placeholder="请选择">
							<el-option label="内资" value="0"></el-option>
							<el-option label="合资" value="1"></el-option>
							<el-option label="独资" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="结算币别" prop="curno">
						<el-select v-model="form.curno" placeholder="请选择">
							<el-option label="人民币" value="001"></el-option>
							<el-option label="美元" value="002"></el-option>
							<el-option label="港币" value="003"></el-option>
							<el-option label="欧元" value="004"></el-option>
							<el-option label="台币" value="005"></el-option>
							<el-option label="英镑" value="006"></el-option>
							<el-option label="泰铢" value="007"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="计税方式" prop="taxmth">
						<el-select v-model="form.taxmth" placeholder="请选择">
							<el-option label="含税" value="0"></el-option>
							<el-option label="未税" value="1"></el-option>
							<el-option label="应税外加" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="税率(%)" prop="cess">
						<el-input v-model="form.cess"></el-input>
					</el-form-item>
					<el-form-item label="结算日" prop="balday">
						<el-input v-model="form.balday"></el-input>
					</el-form-item>
					<el-form-item label="公司邮箱" prop="email">
						<el-input v-model="form.email"></el-input>
					</el-form-item>
					<el-form-item label="公司主页" prop="http">
						<el-input v-model="form.http"></el-input>
					</el-form-item>
					<el-form-item label="联系人" prop="linkman">
						<el-input v-model="form.linkman"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="linktel">
						<el-input v-model="form.linktel"></el-input>
					</el-form-item>
					<el-form-item label="注册手机" prop="regtel">
						<el-input v-model="form.regtel"></el-input>
					</el-form-item>
					<el-button type="primary" plain class="reg-button" :disabled="disable" @click="getVerifyCode()">{{ getCode }}</el-button>
					<el-form-item label="验证码" prop="postcode">
						<el-input v-model="form.postcode" maxlength="6"></el-input>
					</el-form-item>
					
					<el-button type="primary" class="submit-button" @click="submitAccount('form')">开户</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				hasComp: false, 
				form:{
					compno: '',
					compna: '',
					cpcate: 1,
				},
				
				getCode: '获取验证码',
				isGeting: false,
				count: 60,
				disable: false,
				
				
				rules: {
					cocode: [
						{ required: true, message: '请输入公司代码', trigger: 'blur' }
					],
					shortna: [
						{ required: true, message: '请输入公司简称', trigger: 'blur' }
					],
					fullna: [
						{ required: true, message: '请输入公司全称', trigger: 'blur' }
					],
					telno: [
						{ required: true, message: '请输入公司电话', trigger: 'blur' }
					],
					addr: [
						{ required: true, message: '请输入详细地址', trigger: 'blur' }
					],
					ectype: [
						{ required: true, message: '请选择经济类型', trigger: 'blur' }
					],
					curno: [
						{ required: true, message: '请选择结算币别', trigger: 'blur' }
					],
					taxmth: [
						{ required: true, message: '请选择计税方式', trigger: 'blur' }
					],
					cess: [
						{ required: true, message: '请输入税率', trigger: 'blur' }
					],
					balday: [
						{ required: true, message: '请输入结算日', trigger: 'blur' }
					],
					email: [
						{ required: true, message: '请输入公司邮箱', trigger: 'blur' }
					],
					linkman: [
						{ required: true, message: '请输入联系人', trigger: 'blur' }
					],
					linktel: [
						{ required: true, message: '请输入联系电话', trigger: 'blur' }
					],
					regtel: [
						{ required: true, message: '请输入注册手机', trigger: 'blur' }
					],
					postcode: [
						{ required: true, message: '请输入验证码', trigger: 'blur' }
					],
				}
			}
		},
		created() {
			let _this = this;
			
		},
		mounted() {
			
		},
		methods: {
			// 开户
			submitAccount(form) {
				console.log(JSON.stringify(this.form));
				this.$refs[form].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			
			
			// 检测compno是否存在
			checkCocode() {
				let _this = this; 
				let compData = {compno:_this.form.compno};
				console.info(compData)
				
				let index1 = this.$loading({ lock:false, text:'Loading', spinner:'el-icon-loading' });
				
				setTimeout(() => { index1.close(); }, 2000);
				
				// _this.$axios.post('upus_APP/app/employee/compcheck', compData).then(function(result) {
				//   console.info(result.data)
				//   let res = result.data;
				//   // _this.$toast.clear(); //
				//   if(res.success == 0) {
				// 		_this.hasComp = false;
				//     _this.form.compna = '';
				//     return _this.$message({ message:res.msg, type:'warning', offset:'200' });
				//   } else {
				// 		_this.hasComp = true;
				//     _this.form.compna = res.data;
				// 		console.info(JSON.stringify(_this.form))
				//   }
				// })
				// .catch(function(error) {
				// 	console.info(error)
				//   // return _this.$message('error');
				// })
			},
			// 获取倒计时
			getVerifyCode () {
				var countDown = setInterval(() => {
					if (this.count < 1) {
						this.isGeting = false
						this.disable = false;
						this.getCode = '获取验证码';
						this.count = 60;
						clearInterval(countDown);
					} else {
						this.isGeting = true
						this.disable = true;
						this.getCode = this.count-- + 's后重发';
					}
				}, 1000)
			}
		}
	}
</script>

<style scoped>
	.reg-header{
		width: 100%;
		height: 70px;
		background: #fff;
		box-shadow:0px 1px 5px #999;
		text-align: center;
	}
	.reg-header img{
		width: 140px;
		height: 70px;
	}
	.el-form{
		padding-bottom: 200px;
	}
	h2{
		padding: 10px 0px;
		font-weight: 100;
		color: #0391d5;
		border-bottom: 1px solid #0391d5;
	}
	.reg-button{    
    height: 35px;
    padding: 0px 20px;
    margin:0px 0px 20px 180px;
	}
	.currform{
		padding: 0px 10%;
	}
	.cpcate-radio{
		margin-bottom: 15px;
	}
	.cpcate-select{
		margin-top: 20px;
	}
	.submit-button{
		display: block;
		margin: 50px auto;
		padding: 12px 60px;
	}
	@media screen and (max-width: 768px) {
		.container{
			margin: 12px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/account.vue